<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    :fill="color"
    xmlns="http://www.w3.org/2000/svg"
    :style="{ color }"
  >
    <mask id="mask-clockf">
      <path
        d="M12 24C14.1731 24 16.1923 23.4519 18.0577 22.3558C19.8654 21.2981 21.2981 19.8654 22.3558 18.0577C23.4519 16.1923 24 14.1731 24 12C24 9.82692 23.4519 7.80769 22.3558 5.94231C21.2981 4.13461 19.8654 2.70192 18.0577 1.64423C16.1923 0.548077 14.1731 0 12 0C9.84615 0 7.83654 0.548077 5.97115 1.64423C4.16346 2.72115 2.72115 4.16346 1.64423 5.97115C0.548077 7.83654 0 9.84615 0 12C0 14.1538 0.548077 16.1635 1.64423 18.0288C2.70192 19.8365 4.13461 21.2788 5.94231 22.3558C7.80769 23.4519 9.82692 24 12 24ZM17.0769 17.0769L10.8173 13.1827V5.97115H12.6346V12.2308L18.0288 15.4904L17.0769 17.0769Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask-clockf)">
      <path
        d="M12 24C14.1731 24 16.1923 23.4519 18.0577 22.3558C19.8654 21.2981 21.2981 19.8654 22.3558 18.0577C23.4519 16.1923 24 14.1731 24 12C24 9.82692 23.4519 7.80769 22.3558 5.94231C21.2981 4.13461 19.8654 2.70192 18.0577 1.64423C16.1923 0.548077 14.1731 0 12 0C9.84615 0 7.83654 0.548077 5.97115 1.64423C4.16346 2.72115 2.72115 4.16346 1.64423 5.97115C0.548077 7.83654 0 9.84615 0 12C0 14.1538 0.548077 16.1635 1.64423 18.0288C2.70192 19.8365 4.13461 21.2788 5.94231 22.3558C7.80769 23.4519 9.82692 24 12 24ZM17.0769 17.0769L10.8173 13.1827V5.97115H12.6346V12.2308L18.0288 15.4904L17.0769 17.0769Z"
      />
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';

export default {
  name: 'ClockfSVG',
  props: {
    size: VueTypes.number.isRequired,
    color: VueTypes.string.isRequired,
  },
};
</script>
